import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/vehicleconditions');
}
//Get all active
export function allActive(){
    return http().get('/vehicleconditions/active');
}
//Get Single
export function single(id){
    return http().get(`/vehicleconditions/${id}`);
}
//Add one
export function add(data){
    return http().post('/vehicleconditions', data)
}
//Update
export function update(id, data){
    return http().put(`/vehicleconditions/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/vehicleconditions/${id}`);
}